// Mock data for Anel website

// Local Asset Imports
import team1 from '../assets/images/team/member-1.jpg';
import team2 from '../assets/images/team/member-2.jpg';
import team3 from '../assets/images/team/member-3.jpg';
import team4 from '../assets/images/team/member-4.jpg';

import client1 from '../assets/images/clients/client-1.png';
import client2 from '../assets/images/clients/client-2.png';
import client3 from '../assets/images/clients/client-3.png';
import client4 from '../assets/images/clients/client-4.png';
import client5 from '../assets/images/clients/client-5.png';
import client6 from '../assets/images/clients/client-6.png';
import client7 from '../assets/images/clients/client-7.png';
import client8 from '../assets/images/clients/client-8.png';
import client9 from '../assets/images/clients/client-9.png';

import project1 from '../assets/images/portfolio/project-1.jpg';
import project2 from '../assets/images/portfolio/project-2.jpg';
import project3 from '../assets/images/portfolio/project-3.jpg';
import project4 from '../assets/images/portfolio/project-4.jpg';

export const services = [
  {
    id: 1,
    title: "Brand & Visual Identity",
    description: "We develop brand systems that are clear, scalable, and culturally relevant.",
    includes: [
      "Brand strategy & positioning",
      "Logo & visual identity systems",
      "Brand guidelines",
      "Campaign visual direction"
    ],
    price: "Starting from ₦300,000"
  },
  {
    id: 2,
    title: "Media Design & Content Production",
    description: "We create media assets that communicate, persuade, and perform across channels.",
    includes: [
      "Social media design & content",
      "Motion graphics & short-form videos",
      "Campaign creatives",
      "Presentation & pitch materials"
    ],
    price: "Starting from ₦350k/Month"
  },
  {
    id: 3,
    title: "Campaign & Creative Direction",
    description: "We support brands with end-to-end creative direction for launches, events, and marketing campaigns.",
    includes: [
      "Creative concepts",
      "Campaign visuals & rollout assets",
      "Media consistency across platforms",
      "Vendor & production supervision"
    ],
    price: "Starting from ₦400k/one-off"
  },
  {
    id: 4,
    title: "Social Media Management",
    description: "We manage and grow brand presence across social platforms through strategic content, consistent visuals, and audience-focused storytelling.",
    includes: [
      "Content strategy & planning",
      "Social media design & content creation",
      "Community engagement support",
      "Performance tracking & content optimisation"
    ],
    price: "Custom Quote"
  },
  {
    id: 5,
    title: "Event Branding",
    description: "We design and manage cohesive visual experiences for events, ensuring brand consistency across physical and digital touchpoints.",
    includes: [
      "Event visual identity & theme direction",
      "Stage, backdrop & environmental branding",
      "Digital & print event assets",
      "On-ground branding supervision"
    ],
    price: "Custom Quote"
  }
];

export const portfolioCategories = [
  "Brand Identity",
  "Visual Campaigns",
  "Event Branding",
  "Social Media Management"
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Corporate Rebrand",
    client: "TechStart Nigeria",
    category: "Brand Identity",
    summary: "Complete brand overhaul for a leading tech startup",
    outcome: "150% increase in brand recognition",
    image: project1
  },
  {
    id: 2,
    title: "Product Launch Campaign",
    client: "GreenLife Foods",
    category: "Visual Campaigns",
    summary: "360° launch campaign for new product line",
    outcome: "200K+ social impressions in first week",
    image: project2
  },
  {
    id: 3,
    title: "Annual Conference Branding",
    client: "Finance Summit Africa",
    category: "Event Branding",
    summary: "Complete event identity and environmental design",
    outcome: "Most visually cohesive event to date",
    image: project3
  },
  {
    id: 4,
    title: "Social Growth Strategy",
    client: "Urban Fashion Co.",
    category: "Social Media Management",
    summary: "6-month social media transformation",
    outcome: "300% follower growth, 5x engagement",
    image: project4
  }
];

export const clientTypes = [
  "Startups & growing businesses",
  "Corporate brands",
  "Educational institutions",
  "NGOs & social initiatives",
  "Personal brands & creators"
];

export const testimonials = [
  {
    id: 1,
    quote: "Working with Anel has been productive in building my coaching business. As a visionary, I needed someone who could truly comprehend my vision and interpret it into compelling design. From flyers and logos to my complete branding package and landing pages, Anel delivered work that not only captivates but communicates my vision clearly. What stands out most is their creativity, professionalism, and ability to bring my ideas to life.",
    name: "Esther Popoola",
    company: "Toplead",
    role: "Lead Coach"
  },
  {
    id: 2,
    quote: "I've had the pleasure of working with Anel on several projects, and every experience has been exceptional. They consistently deliver designs that are not only visually stunning but also strategically aligned with brand goals. Their professionalism, creativity, and attention to detail make them reliable for any business looking to elevate its visual presence.",
    name: "Edoja Richard",
    company: "Ignite Conference",
    role: "Convener"
  },
  {
    id: 3,
    quote: "Anel is very easy to work with.",
    name: "Olayinka Philip-Aina",
    company: "",
    role: "Business Consultant"
  },
  {
    id: 4,
    quote: "Anel is a truly exceptional brand, distinguished by its professionalism and creative excellence. Their swift turnaround, meticulous attention to detail, and unwavering commitment to customer satisfaction set them in a league of their own, making them my first choice for every project.",
    name: "Ndifreke George",
    company: "WRITERHOLICS",
    role: "Founder"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Emmanuel Ojodun",
    role: "Creative Director",
    summary: "Leads design strategy, brand direction, and major creative projects.",
    image: team1,
    linkedin: "https://www.linkedin.com/in/emmanuelojodun/"
  },
  {
    id: 2,
    name: "Eunice Aimiuwu",
    role: "Business and Data Strategist",
    summary: "Drives data-informed decisions and strategic business insights.",
    image: team2,
    linkedin: "https://www.linkedin.com/in/eunice-a-04a041140"
  },
  {
    id: 3,
    name: "Mofe Richard",
    role: "Business and Brand Strategist",
    summary: "Crafts compelling brand narratives and strategic positioning.",
    image: team3,
    linkedin: "https://www.linkedin.com/in/mofe-richard-0a5849234/"
  },
  {
    id: 4,
    name: "Tabeel Agada",
    role: "Product Evangelist",
    summary: "Creates engaging content that resonates with target audiences.",
    image: team4,
    linkedin: "https://www.linkedin.com/in/tabeel-agada/"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "How Branding Shapes Customer Trust",
    excerpt: "The modern marketplace elevates the concept of a brand from a mere visual identifier to a profound strategic asset—the very 'soul' of the business. The formation of customer trust is no longer an accidental byproduct of commerce; it is a meticulously engineered outcome of intentional branding that focuses on the 'Why' of an organization.",
    category: "Design Thinking",
    date: "Aug 15, 2025",
    fullContent: `The modern marketplace is characterized by a shift in consumer behavior that elevates the concept of a brand from a mere visual identifier to a profound strategic asset—the very "soul" of the business.

This evolution is particularly visible in sectors ranging from the disruptive automotive industries led by giants like Tesla and indigenous pioneers such as Innoson Vehicle Manufacturing (IVM). The formation of customer trust is no longer an accidental byproduct of commerce; it is a meticulously engineered outcome of intentional branding that focuses on the "Why" of an organization rather than just its aesthetic "What."

The most successful brands in the world, including Tesla and Apple, operate on a principle known as the "Golden Circle," a theory posited by Simon Sinek. This theory argues that while every company knows what they do and how they do it, very few can articulate why they do it. The "Why" is the purpose, cause, or belief that serves as the foundation for the organization's existence beyond the bottom line.

In Nigeria, digital branding is not merely an option; it is a necessity for establishing legitimacy. A business that lacks a searchable online presence is often viewed with suspicion. Building a solid digital foundation involves understanding that Nigerians are passionate and community-driven.

Branding is finalized at the level of service. Every inquiry, complaint, and support ticket is a "brand touchpoint" that has the power to either reinforce or destroy customer loyalty.

In Nigeria, where customer service is often a primary pain point, organizations that prioritize responsiveness and empathy gain a massive ROI.

By prioritizing clarity, consistency, and the "Why" behind their existence, brands can cut through the noise of the digital marketplace and forge bonds with their customers that are as durable as the products they manufacture and as resilient as the infrastructure they build. Trust is not a gift from the market; it is a hard-earned asset that results from giving your all to ensure every customer understands the totality of what your brand stands for.`
  },
  {
    id: 2,
    title: "How Businesses are Doubling Sales with Better Visuals",
    excerpt: "In the competitive landscape of modern business, the first 'handshake' between your brand and a potential customer is your visuals. Research indicates that most shoppers glance at a product for less than three seconds, and within that window, they must perceive its value and interest.",
    category: "Business Growth",
    date: "Aug 10, 2025",
    fullContent: `In the competitive landscape of modern business the first "handshake" between your brand and a potential customer is your visuals. Research indicates that most shoppers glance at a product for less than three seconds, and within that window, they must perceive its value and interest. To help your business bridge the gap between "just looking" and "buying," here is a refined look at how better visuals can double your sales.

If you have ever participated in window shopping, you know that you often decide a product fits your personality, whether it is a luxury watch or a designer dress long before you ever touch it.

This is due to a psychological phenomenon called processing fluency. When a brand presents itself with clear, professional visuals, the customer's brain processes the information with less effort. This "cognitive ease" creates an immediate sense of trust and reliability.

Conversely, inconsistent or cluttered visuals trigger "cognitive dissonance," setting off subconscious red flags that make a customer hesitate. In an era of "eye-level is buy-level," your visual presentation must act as a mental shortcut that helps customers make confident decisions quickly.

One of the most common mistakes small businesses make is waiting until they are "big" to invest in their look. However, an intentional brand strategy requires you to present your business in a manner that reflects the goals you have for it, not just your current size.

If you are selling a high-ticket product or a premium service, but your designs look unpolished or "in the trenches," you create a disconnect. This gap in perception can be detrimental; you may be targeting high-value clients but only attracting those who negotiate on price because your brand doesn't "look" the part. Strategic design encompassing professional typography, a consistent color palette, and high-quality visual assets signals credibility and authority from day one.

Branding is the totality of what your business stands for. If you give it your all and ensure every visual element aligns with your "Why," you move from being a simple service provider to a trusted authority. Don't let poor design be the barrier that keeps your sales from doubling. Start visualizing the brand you want to become, and your customers will start seeing it too.`
  }
];

export const contactInfo = {
  email: "aneldesigninstitute@gmail.com",
  location: "Badagry, Lagos, Nigeria",
  availability: "Remote & Hybrid Projects"
};

export const socialLinks = {
  instagram: "https://www.instagram.com/anelltd?igsh=MTBmamFtOWF0ZWUwdw==",
  linkedin: "https://www.linkedin.com/company/anelltd/",
  twitter: "https://x.com/OjodunEmmanuel",
  behance: "https://www.behance.net/aneldesigns"
};

export const clientLogos = [
  {
    name: "JMK Accounting",
    logo: client1
  },
  {
    name: "Chadash",
    logo: client2
  },
  {
    name: "Appettie Food",
    logo: client3
  },
  {
    name: "Tanbimex Pharmacy",
    logo: client4
  },
  {
    name: "Writerholics",
    logo: client5
  },
  {
    name: "Yes You Can Education",
    logo: client6
  },
  {
    name: "JONAPWD",
    logo: client7
  },
  {
    name: "Ojoduworks",
    logo: client8
  },
  {
    name: "Toplead",
    logo: client9
  }
];

// Company stats
export const stats = {
  projectsCompleted: "40+",
  clientSatisfaction: "98%",
  yearsExperience: "5+"
};

// Company pillars
export const companyPillars = {
  vision: "To inspire clarity and purpose in every brand story.",
  mission: "To help brands communicate clearly and grow through strategic media and creative storytelling.",
  approach: "Human-centric, insight-driven, and outcome-oriented."
};
